import React from "react";
import './ourhostoy.css';
const history1 =  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742207627/1_dnyzas.jpg";
const history2 =  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742207627/1_dnyzas.jpg";
const history3 =  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742214442/2_yhgkq5.jpg";
const history4 =  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742207621/3_cihuev.jpg";

const ourhistory = () => {
    return (
        <>
            <div className="about-dasmesh-section-1" >
                <h3>ACCOMPLISHMENTS</h3>
                {/* <div className="our-history-sect-2">
                    <div className="row">
                        <div className="our-history-para-1">
                            <div className="our-history-year">1982<svg xmlns="http://www.w3.org/2000/svg" width="84" height="6" viewBox="0 0 84 6" fill="none">
                                <path d="M3 3H81" stroke="#ED3237" stroke-width="6" stroke-linecap="round" stroke-dasharray="12 12" />
                            </svg></div>
                            <h4>Establishment of the First Unit for Agricultural Implements</h4>
                            <p>In 1982, DASMESH laid the foundation by establishing its first manufacturing unit dedicated to agricultural implements. This marked the beginning of our commitment to producing high-quality equipment like Rotavators and Seeders, designed to enhance farming efficiency and productivity.</p>
                            <div className="our-history-year-image-right"><img src={history1} alt="history1" /></div>
                        </div>
                    </div>
                </div>
                <div className="our-history-sect-2">
                    <div className="row">
                        <div className="our-history-para-1">
                            <div className="our-history-year-2"><svg xmlns="http://www.w3.org/2000/svg" width="84" height="6" viewBox="0 0 84 6" fill="none">
                                <path d="M3 3H81" stroke="#ED3237" stroke-width="6" stroke-linecap="round" stroke-dasharray="12 12" />
                            </svg>1999</div>
                            <h4>Awarded the Udyog Bhushan Award</h4>
                            <p>In 1999, DASMESH was honored with the prestigious Udyog Bhushan Award, presented by the Government of India. This recognition highlighted our excellence in the agricultural machinery industry and our continued commitment to innovation, quality, and supporting the farming community.</p>

                            <div className="our-history-year-image-left-award"><img src={history4} alt="history1" /></div>
                        </div>
                    </div>
                </div>
                <div className="our-history-sect-2">
                    <div className="row">
                        <div className="our-history-para-1">
                            <div className="our-history-year">2002<svg xmlns="http://www.w3.org/2000/svg" width="84" height="6" viewBox="0 0 84 6" fill="none">
                                <path d="M3 3H81" stroke="#ED3237" stroke-width="6" stroke-linecap="round" stroke-dasharray="12 12" />
                            </svg> </div>
                            <h4>New Unit Established for Combine Harvesters & Implements</h4>
                            <p>In 2002, DASMESH expanded its capabilities by establishing a new manufacturing unit focused on producing Combine Harvesters and agricultural implements. This step strengthened our position in the industry, allowing us to deliver advanced, high-performance machinery to meet the evolving needs of farmers.</p>
                            <div className="our-history-year-image-right"><img src={history3} alt="history1" /></div>
                        </div>
                    </div>
                </div>
                <div className="our-history-sect-2">
                    <div className="row">
                        <div className="our-history-para-1">
                            <div className="our-history-year-2"><svg xmlns="http://www.w3.org/2000/svg" width="84" height="6" viewBox="0 0 84 6" fill="none">
                                <path d="M3 3H81" stroke="#ED3237" stroke-width="6" stroke-linecap="round" stroke-dasharray="12 12" />
                            </svg>2019</div>
                            <h4>New Unit Established for Agricultural Implements</h4>
                            <p>In 2019, DASMESH further expanded its operations by establishing a dedicated unit for agricultural implements. This specialized facility enhanced our ability to innovate and produce a wider range of high-quality farming equipment, reinforcing our commitment to supporting farmers with reliable and efficient solutions.</p>
                            <div className="our-history-year-image-left"><img src={history2} alt="history1" /></div>
                        </div>
                    </div>
                </div> */}


                <div className="timeline-container">
                    <div className="timeline-item">
                        <div className="timeline-date">1982 <span>----</span></div>
                        <img src={history1} className="mobile-view" alt="1982 Event" />
                        <div className="timeline-content">
                            <h4>Establishment of the First Unit for Agricultural Implements</h4>
                            <p>In 1982, DASMESH laid the foundation by establishing its first manufacturing unit dedicated to agricultural implements. This marked the beginning of our commitment to producing high-quality equipment like Rotavators and Seeders, designed to enhance farming efficiency and productivity.</p>
                        </div>
                        <img src={history1} className="desktop-view" alt="1982 Event" />
                    </div>

                    <div className="timeline-item">
                        <div className="timeline-date mobile-view"> <span>----</span> 1999</div>
                        <img src={history4} alt="1999 Event" />
                        <div className="timeline-content">
                            <h4>Awarded the Udyog Bhushan Award</h4>
                            <p>In 1999, DASMESH was honored with the prestigious Udyog Bhushan Award, presented by the Government of India. This recognition highlighted our excellence in the agricultural machinery industry and our continued commitment to innovation, quality, and supporting the farming community.</p>
                        </div>
                        <div className="timeline-date desktop-view"> <span>----</span> 1999</div>
                    </div>

                    <div className="timeline-item">
                        <div className="timeline-date">2002 <span>----</span></div>
                        <img src={history3} className="mobile-view" alt="2002 Event" />
                        <div className="timeline-content">
                            <h4>New Unit Established for Combine Harvesters & Implements</h4>
                            <p>In 2002, DASMESH expanded its capabilities by establishing a new manufacturing unit focused on producing Combine Harvesters and agricultural implements. This step strengthened our position in the industry, allowing us to deliver advanced, high-performance machinery to meet the evolving needs of farmers.</p>
                        </div>
                        <img src={history3} className="desktop-view" alt="2002 Event" />
                    </div>

                    <div className="timeline-item">
                        <div className="timeline-date mobile-view"> <span>----</span> 2019</div>
                        <img src={history2} alt="2019 Event" />
                        <div className="timeline-content">
                            <h4>New Unit Established for Agricultural Implements</h4>
                            <p>In 2019, DASMESH further expanded its operations by establishing a dedicated unit for agricultural implements. This specialized facility enhanced our ability to innovate and produce a wider range of high-quality farming equipment, reinforcing our commitment to supporting farmers with reliable and efficient solutions.</p>
                        </div>
                        <div className="timeline-date desktop-view"> <span>----</span> 2019</div>
                    </div>
                </div>
            </div>
        </>

    )
};

export default ourhistory;